import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

export const InquiryForm = ({ courseSlug = "medical-devices-15-day", compact = false }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    qualification: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/inquiries", { ...form, course_slug: courseSlug });
      toast.success("Enquiry received! Our team will call you within 24 hours.");
      setForm({ name: "", email: "", phone: "", qualification: "", message: "" });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Could not submit. Try again.";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls =
    "w-full rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#0A3B32]/30 focus:border-[#0A3B32] transition-all";

  return (
    <form
      onSubmit={submit}
      className={`${compact ? "" : "card-soft"} space-y-4`}
      data-testid="inquiry-form"
    >
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-semibold text-slate-700 mb-1.5">Full Name</label>
          <input
            data-testid="inquiry-name"
            required
            value={form.name}
            onChange={set("name")}
            placeholder="Your full name"
            className={inputCls}
          />
        </div>
        <div>
          <label className="block text-xs font-semibold text-slate-700 mb-1.5">Phone</label>
          <input
            data-testid="inquiry-phone"
            required
            value={form.phone}
            onChange={set("phone")}
            placeholder="+91 9XXXXXXXXX"
            className={inputCls}
          />
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-semibold text-slate-700 mb-1.5">Email</label>
          <input
            data-testid="inquiry-email"
            type="email"
            required
            value={form.email}
            onChange={set("email")}
            placeholder="you@example.com"
            className={inputCls}
          />
        </div>
        <div>
          <label className="block text-xs font-semibold text-slate-700 mb-1.5">Qualification</label>
          <input
            data-testid="inquiry-qualification"
            required
            value={form.qualification}
            onChange={set("qualification")}
            placeholder="B.Sc / B.E. / Diploma / ..."
            className={inputCls}
          />
        </div>
      </div>
      <div>
        <label className="block text-xs font-semibold text-slate-700 mb-1.5">Message (optional)</label>
        <textarea
          data-testid="inquiry-message"
          rows={3}
          value={form.message}
          onChange={set("message")}
          placeholder="Tell us about your interest…"
          className={inputCls}
        />
      </div>
      <button
        type="submit"
        disabled={submitting}
        data-testid="inquiry-submit"
        className="btn-primary w-full disabled:opacity-60 disabled:cursor-not-allowed"
      >
        <Send size={18} />
        {submitting ? "Submitting…" : "Reserve my seat — Free"}
      </button>
      <p className="text-xs text-center text-slate-500">
        We respect your privacy. Your data is only used to contact you.
      </p>
    </form>
  );
};
